import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { PoNotificationService } from '@po-ui/ng-components';
import { MainService } from 'src/app/app.service';
import { Roles } from 'src/app/enums/roles';

/**
 * Restringe as rotas abaixo de Admin > MCP > Reports (ex.: Documenta.AI) a quem
 * tem a role granular do report (ex.: `mcp:reports:documenta-ai`), a role
 * wildcard `mcp:reports` (`mcp:reports:*`) ou `superuser` -- mesmo critério de
 * autorização do backend (ver ROLES_POLICY em auth/service.js), onde a role
 * granular também concede acesso e não só a wildcard. O `route.data['role']`
 * carrega a role granular exigida por cada report, então o guard não fica
 * amarrado a um report específico. Checagem local via `sRoles`, já hidratado
 * pelo AuthGuard/login -- sem probe HTTP extra, igual ao padrão de menu.component
 * (matchesUserType) usado para as demais roles do produto.
 */
@Injectable({
  providedIn: 'root',
})
export class McpReportsGuard {
  constructor(
    private mainService: MainService,
    private router: Router,
    private poNotification: PoNotificationService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean {
    const roles: Array<string> = this.mainService.sRoles || [];
    const requiredRole: string | undefined = route.data?.['role'];

    if (
      roles.includes(Roles.SUPERUSER) ||
      roles.includes(Roles.MCP_REPORTS) ||
      (!!requiredRole && roles.includes(requiredRole))
    ) {
      return true;
    }

    this.poNotification.warning('Você não tem permissão para acessar os relatórios do MCP.');
    this.router.navigate(['menu/home']);
    return false;
  }
}
